import { Form } from 'antd'
import type { ZodType } from 'zod'
import type { FormItemSchema } from '../schemas'
import { withParsedData } from './base'

export function withFormItem<Schema extends FormItemSchema>(schema: ZodType<Schema>) {
  return function (getChildren: (props: Omit<Schema, 'label' | 'name' | 'preserve' | 'rules'>) => JSX.Element) {
    return withParsedData(schema)(({ parsedData, ...restProps }) => {
      const { label, name, preserve, rules, ...childrenProps } = parsedData

      return (
        <Form.Item label={label} name={name} rules={rules} preserve={preserve} {...restProps}>
          {getChildren(childrenProps)}
        </Form.Item>
      )
    })
  }
}
